import { occurrenceType, plannerEvent } from  "@/interfaces/planner";
import moment from "moment";
import { datesSame, endOfDayTime, removeTime } from "./Dates";

const multiDayBuilder = function(events:plannerEvent[], date:Date){

    const startOfDay = removeTime(date)
    const endOfDay = endOfDayTime(date)

    // Left side
    const startsToday = events.filter(x => {

        const {start, end} = x.occurrence

        // Starts today
        return start.getFullYear() === date.getFullYear() 
        && start.getMonth() === date.getMonth() 
        && start.getDate() === date.getDate()

        // Finishes later
        && end > endOfDay

    }).map(x => {
        return {
            ...x,
            occurrence: {
                ...x.occurrence,
                firstDay:true
            }    
        }
    });
    
    // Middle day
    const passThroughDay = events.filter(x => {

        const {start, end} = x.occurrence

        // Starts before today & finishes after
        return start < startOfDay && end > endOfDay
    })

    // Right side
    const endsToday = events.filter(x => {

        const {start, end} = x.occurrence

        // Starts today
        return end.getFullYear() === date.getFullYear() 
        && end.getMonth() === date.getMonth() 
        && end.getDate() === date.getDate()

        // Finishes later
        && start < startOfDay
    })

    // if event starts previous week
    const combineDays = [...addSpan(startsToday, "join-right"), ...addSpan(passThroughDay, "join-both"), ...addSpan(endsToday, "join-left")]

    // Order by dayspan - longest event at top
    const withOrder = combineDays.sort((a, b) => b.occurrence.daySpan - a.occurrence.daySpan);

    const rows = events.filter(x => x.occurrence.daySpan >= 1).sort((a, b) => b.occurrence.daySpan - a.occurrence.daySpan);

    // Should always output either blank or event - dependant on rows
    const withBlank:plannerEvent[] = [];

    rows.forEach((row,i) => {

        let hasDay = withOrder.filter(x => x.id === row.id)

        if (hasDay.length){
            // Event for this day - add
            withBlank.push(hasDay[0])
        }
        else{
            // Needs a blank - spacer day    
            const blankEvent:plannerEvent = {
                "id": 0,
                "title": "",
                "location": {
                    "name": ""
                },
                "occurrence": {
                    "start": new Date(),
                    "end": new Date(),
                    "occurrenceType": occurrenceType.StartEnd,
                    "daySpan": 0,
                    "span": "blank"
                },
                "description": "",
                "allowAttendeesResponseUpdates":true,
                registrationStatus: 'Open',             
            }

            withBlank.push(blankEvent)
        } 
    });

    return withBlank
}

function addSpan(events:plannerEvent[], classRef:string){

    return [...events].map(evt => {
        return {
            ...evt,
            occurrence:{
                ...evt.occurrence,
                span:classRef
            }
        }
    })
}

const daySpan = function(start, end){

    const dayStart = moment(start)
    const dayEnd = moment(end)

    // if event starts and ends it has a span of 0 - up from 1
    if(dayStart.dayOfYear() === dayEnd.dayOfYear()) {
        return 0;
    }
    
    return Math.ceil(dayEnd.diff(dayStart, 'days', true))
}

const isValidStartEndTime = (startTimeLocal:string, endTimeLocal:string, calDate:Date[]) => {

    const startHour = parseInt(startTimeLocal.split(':')[0])
    const startMin = parseInt(startTimeLocal.split(':')[1])
    const start = parseFloat(`${startHour}.${startMin}`)

    const endHour = parseInt(endTimeLocal.split(':')[0])
    const endMin = parseInt(endTimeLocal.split(':')[1])
    const end = parseFloat(`${endHour}.${endMin}`)

    // No validation if multi-day event
    if (calDate.length === 2){
        return true
    }
    // Is end time after start?
    if (start >= end){
        return false
    }

    // Is time in past? Only if its today
    if(calDate.length){

        const now = new Date();

        if (datesSame(calDate[0], now)){
            const nowDeci = parseFloat(`${now.getHours()}.${now.getMinutes()}`)

            if (start < nowDeci || end < nowDeci){
                return false
            }
        }
    }
    
    return true    
}

export {multiDayBuilder, daySpan, isValidStartEndTime}